export const providersSelector = ({ sessionData: { providers } }) => providers;

export const providerInfoSelector = (
  { sessionData: { providers } },
  providerId
) => providers[providerId];
